module.exports = __webpack_public_path__ + "img/0Q3B7497_FoamcoreMatted.38330608.jpg";